import { Status } from '../../../models';

export const createNewCompanyContent = (
  companyStatus?: Status,
  numberOfProjects?: number
): {
  image: string;
  title: string;
  link: string;
  isDisabled?: boolean;
  isHidden?: boolean;
}[] => {
  return [
    {
      image: 'basic-info',
      title: 'Basic Info',
      link: 'basic-info',
    },
    {
      image: 'contact-info',
      title: 'Contact Info',
      link: 'contact-info',
    },
    {
      image: 'team',
      title: 'Team',
      link: 'team',
    },
    {
      image: 'projects',
      title: 'Projects',
      link: 'projects',
      isDisabled: companyStatus !== Status.Active && numberOfProjects <= 0,
    },
    {
      image: 'subscription-plans',
      title: 'Subscription Plans',
      link: 'subscription-plans',
    },
    {
      image: 'form-templates',
      title: 'Form Templates',
      link: 'form-templates',
      isHidden: true,
    },
  ];
};
